export default function getMeetingLink(meetingId: string): string {
    return `${window.location.protocol}//${window.location.host}/login/${meetingId}`;
}
